import React, {Component} from 'react';
import moment from 'moment';
import Immutable from 'immutable';
import WorkerScheduleRow from './WorkerScheduleRow';

const TableHeader = () => (
  <thead>
    <tr>
      <th>日期</th>
      <th>上午</th>
      <th>下午</th>
      <th>加班</th>
    </tr>
  </thead>
)

class WorkerSchedule extends Component {
  render() {
    let {dispatch, shiftRecord, year, month, siteList, positionList, user, sessionConfig} = this.props;
    let lookingMonth = year + '-' + month;
    let reverseSiteList = Immutable.fromJS(siteList.toArray().reverse());
    let siteListWithHoliday = reverseSiteList.splice(0, 0, Immutable.fromJS({cid: -1, name:"事假", status: 0, year: 0}))
                                      .splice(0, 0, Immutable.fromJS({cid: -2, name:"休假", status: 0, year: 0}));
    return (
      <div className="result schedule">
        <table className="table table-hover">
          <TableHeader />
          <tbody>
            {[...Array(moment(lookingMonth, "YYYY-MM").daysInMonth()).keys()].map((date)=> {
              date += 1;
              if (date < 10) date = "0" + date;
              let mornShift = shiftRecord.get(date + "-0");
              let aftnShift = shiftRecord.get(date + "-1");
              let otShift = shiftRecord.get(date + "-2");

              date = moment(lookingMonth + "-" + date, "YYYY-MM-DD");
              return (
                <WorkerScheduleRow
                  key={date.format("MM-DD")}
                  dispatch={dispatch}
                  date={date}
                  mornShift={mornShift}
                  aftnShift={aftnShift}
                  otShift={otShift}
                  siteList={siteListWithHoliday}
                  positionList={positionList}
                  user={user}
                  sessionConfig={sessionConfig}
                />
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

export default WorkerSchedule;



// WEBPACK FOOTER //
// ./src/components/Schedule/WorkerSchedule.js